module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm_head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062899897_Cover#cover",
      "id": "rcover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062899897_Titlepage#title",
      "id": "rtitle"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "con1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062899897_Chapter_1"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "con1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-1",
      "id": "r_idParaDest-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062899897_Also_by#_idParaDest-2",
      "id": "r_idParaDest-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Also by Olaf Olafsson")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062899897_Copyright#_idParaDest-3",
      "id": "r_idParaDest-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "con"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-4",
      "id": "r_idParaDest-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-667ffb3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062899897_Contents.vue
// module id = 63
// module chunks = 0